import React, { useCallback, useEffect, useState } from 'react'
import { CCard, CCardBody } from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import EmailQuotaService from 'src/service/EmailQuotaService'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaPanel from './EmailQuotaPanel'
import AutomatedEmails from './AutomatedEmails'
import OneOffEmails from './OneOffEmails'
import CreatEmailMember from './CreatEmailMember'
import './GameNotification.css'

const AUTOMATED = 'automated'
const ONE_OFF = 'one-off'
const MEMBERS = 'members'

const TABS = [
  { key: AUTOMATED, label: 'Automated', count: 2 },
  { key: ONE_OFF, label: 'One-off sends', count: 3 },
  { key: MEMBERS, label: 'Email members' },
]

const GameNotification = () => {
  const [activeTab, setActiveTab] = useState(AUTOMATED)
  const [hourValue, setHourValue] = useState({})
  const [enableDisableStatus, setEnableDisableStatus] = useState({})
  const [alertCount, setAlertCount] = useState({})

  useEffect(() => {
    CommonService.getEmailNotficationSetting().then((res) => {
      if (res.status === 200) {
        const settings = res.data || []
        setEnableDisableStatus(
          settings.reduce((acc, item) => {
            acc[item.template_id] = item.is_enable
            return acc
          }, {}),
        )
        setHourValue(
          settings.reduce((acc, item) => {
            acc[item.template_id] = item.duration
            return acc
          }, {}),
        )
      }
    })
  }, [])

  const fetchAlertCount = useCallback(() => {
    EmailQuotaService.getEmailAlertCount().then((res) => {
      if (res.status === 200) {
        setAlertCount(res.data)
      }
    })
  }, [])

  useEffect(() => {
    fetchAlertCount()
  }, [fetchAlertCount])

  const handleHourChange = (event, id) => {
    setHourValue((current) => ({ ...current, [id]: event.target.value }))
  }

  const handleEnableDisableChangeStatus = (event, id) => {
    setEnableDisableStatus((current) => ({ ...current, [id]: event.target.checked }))

    CommonService.changeEmailNotificationEnableDisable({
      template_id: id,
      is_enable: event.target.checked,
    }).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  const handleSaveEmailNotificationSettingUpdated = (template_id, duration) => {
    CommonService.saveEmailNotificationSetting({ template_id, duration }).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Email Notifications</h1>
        <p className="ge-page-subtitle">
          Automated reminders and one-off emails sent to the members of this game.
        </p>
      </div>

      <EmailQuotaPanel />

      <div className="ge-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            {tab.count !== undefined && <span className="ge-tab-count">{tab.count}</span>}
          </button>
        ))}
      </div>

      {activeTab === AUTOMATED && (
        <CCard className="gn-panel">
          <CCardBody>
            <div className="gn-panel-head">
              <h2 className="gn-panel-title">Automated reminders</h2>
              <p className="gn-panel-note">
                These send on their own around each round. Set when they go out, then switch them
                on.
              </p>
            </div>
            <AutomatedEmails
              alertCount={alertCount}
              hourValue={hourValue}
              enableDisableStatus={enableDisableStatus}
              handleHourChange={handleHourChange}
              handleEnableDisableChangeStatus={handleEnableDisableChangeStatus}
              handleSaveEmailNotificationSettingUpdated={handleSaveEmailNotificationSettingUpdated}
            />
          </CCardBody>
        </CCard>
      )}

      {activeTab === ONE_OFF && (
        <CCard className="gn-panel">
          <CCardBody>
            <div className="gn-panel-head">
              <h2 className="gn-panel-title">One-off sends</h2>
              <p className="gn-panel-note">
                Nothing is scheduled here — each email goes out to every member the moment you send
                it.
              </p>
            </div>
            <OneOffEmails alertCount={alertCount} refreshCounts={fetchAlertCount} />
          </CCardBody>
        </CCard>
      )}

      {activeTab === MEMBERS && (
        <CCard className="gn-panel">
          <CCardBody>
            <div className="gn-panel-head">
              <h2 className="gn-panel-title">Email members</h2>
              <p className="gn-panel-note">
                Write one message, choose who gets it, then send it from the queue when you are
                ready.
              </p>
            </div>
            <CreatEmailMember />
          </CCardBody>
        </CCard>
      )}
    </>
  )
}

export default GameNotification
